import Utility from "../../../../utility/utility";
import LanguageManager from "../../../../manager/language_manager";
import GameUtil from "../../../../utility/game_util";

const {ccclass, property} = cc._decorator;

@ccclass
export default class RecordItem extends cc.Component {

    @property(cc.Label)
    indexLab:cc.Label = null

    @property(cc.Label)
    countLab:cc.Label = null

    @property(cc.Label)
    timeLab:cc.Label = null

    @property(cc.Label)
    roomLab:cc.Label = null

    @property(cc.Label)
    numberLab:cc.Label = null

    @property(cc.Sprite)
    goldSpr:cc.Sprite = null

    @property(cc.Sprite)
    bg:cc.Sprite = null

    @property(cc.Node)
    infoNode:cc.Node = null

    @property(cc.SpriteFrame)
    goldTypeSpr:cc.SpriteFrame[] = []

    @property(cc.SpriteFrame)
    bgSprs:cc.SpriteFrame[] = []

    changciString =null; //[LanguageManager.t("public_chuRoom"), LanguageManager.t("public_zhonRoom"), LanguageManager.t("public_gaoRoom"), "大师场"]
    // LIFE-CYCLE CALLBACKS:

    onLoad () {
        this.changciString =[LanguageManager.t("public_mangoRoom"), LanguageManager.t("public_chuRoom"), LanguageManager.t("public_zhonRoom"), LanguageManager.t("public_gaoRoom"),LanguageManager.t("public_zhizunRoom"),LanguageManager.t("public_wangzheRoom")]
    }

    start () {

    }

    setData( data: any, index: number){
        this.bg.spriteFrame = this.bgSprs[index%2]
        if (data.goldType == null){ 
            this.infoNode.active = false
            return
        } 
        this.infoNode.active = true
        this.indexLab.string = (index + 1).toString()
        this.numberLab.string = data.roundSign
        let roomType = data.accountType == null ? 5 : data.accountType //accountType 5 筹码 6 芒果
        this.roomLab.string = this.changciString[roomType == 6 ? 0 : data.goldType] // accountType 6 芒果场 显示为体验场
        this. timeLab.string =  Utility.timeToStr(data.endTime)
        this.goldSpr.spriteFrame = this.goldTypeSpr[1]
        let w0 = data.winGold - data.lostGold - data.feeGold
        let wl = GameUtil.currencyFormatting(Math.abs(w0))

        if (w0 < 0){
            this.countLab.node.color = new cc.Color(0, 158, 197, 255)
            this.countLab.string = "-" +  wl 
        }
        else{
            this.countLab.node.color = new cc.Color(180, 71, 31, 255)
            this.countLab.string = "+" + wl
        }
    }

    // update (dt) {}
}
